import * as angular from 'angular';

export default class DroppableTargetController {
  static $inject = ['$element'];

  TARGET_SELECTOR = '.drag-drop-target';

  onUpdate: (args: { $contextId: string; $value: string }) => void;
  hasValue: boolean;

  constructor(private $element: angular.IRootElementService) {}

  $postLink = () => {
    const $target = this.$element.find(this.TARGET_SELECTOR);
    const targetElem = $target.get(0);
    const handleValidDragOver = (evt) => {
      evt.preventDefault();
    };

    targetElem.addEventListener('dragover', handleValidDragOver);
    targetElem.addEventListener('drop', (evt) => {
      const serializedData = evt.dataTransfer.getData('data');
      const data = JSON.parse(serializedData);
      const $value = data.value;
      const $contextId = data.contextId;

      evt.preventDefault();
      this.onUpdate({ $contextId, $value });
    });
  };
}
